import { Button } from "@Light/components/page/Button";
import { ButtonFooter } from "@Light/components/page/ButtonFooter";
import { useScaffold } from "@Light/scaffold";

export type NoRenewalOffersProps = {
  onDone: () => void;
};

export const NoRenewalOffers: React.FC<NoRenewalOffersProps> = ({ onDone }) => {
  const scaffold = useScaffold();
  const Title = scaffold.page.title;
  const Subtitle = scaffold.page.subtitle;
  const PageBody = scaffold.page.pageBody;
  const Hyperlink = scaffold.page.hyperlink;

  const goToDashboardOnExit = scaffold.page.goToDashboardOnExit;

  return (
    <PageBody
      footer={
        <ButtonFooter>
          <Button size="lg" className="w-full" onClick={onDone}>
            {goToDashboardOnExit ? "Go to dashboard" : "Okay"}
          </Button>
        </ButtonFooter>
      }
    >
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 px-4 flex flex-col gap-2">
        <Title>No renewal offers are currently available</Title>
        <Subtitle>
          An offer may have expired or you may not currently be eligible for
          renewal. Reach out to us at{" "}
          <Hyperlink href={`mailto:${scaffold.page.supportEmail}`}>
            {scaffold.page.supportEmail}
          </Hyperlink>{" "}
          if you have any questions.
        </Subtitle>
      </div>
    </PageBody>
  );
};
